// Shared list of "sides" and their areas, used by:
//   · JoinIntake (member preferences step 5)
//   · CreateVenueForm (admin desk venue picker · Msg 234)
// Msg 234 §6 (Vania 30 Sep evening) · compass prefix on every side name.
export const AREA_GROUPS = [
  ["northwest · westlands side", ["Westlands", "Parklands", "Spring Valley", "Loresho", "Riverside", "Lavington"]],
  ["west · kilimani side",       ["Kilimani", "Kileleshwa", "Hurlingham", "Upper Hill", "Ngong Road"]],
  ["southwest · karen side",     ["Karen", "Lang'ata", "Rongai", "Ngong"]],
  ["north · gigiri side",        ["Gigiri", "Runda", "Muthaiga", "Rosslyn", "Ruaka", "Kiambu Road"]],
  ["northeast · thika road side",["Kasarani", "Roysambu", "Garden City", "Kahawa", "Ruiru", "Juja"]],
  ["city and south",             ["CBD", "Ngara", "South B", "South C", "Industrial Area", "Syokimau", "Kitengela"]],
  ["east · eastleigh side",      ["Eastleigh", "Buruburu", "Donholm", "Umoja", "Embakasi"]],
];
